import React from 'react';
import { Code, ArrowRight } from 'lucide-react';
import styles from './WebDesignAboutMe.module.css';

const WebDesignAboutMe = () => {
  return (
    <section id="about" className={styles.aboutSection}>
      <div className={styles.aboutContainer}>
        <div className={styles.sectionHeader}>
          <span className={styles.sectionLabelWeb}>Who I Am</span>
          <h2 className={styles.sectionTitleWeb}>About Me</h2>
          <div className={styles.titleUnderlineWeb}></div>
        </div>

        <div className={styles.aboutGrid}>
          {/* <div className={styles.profileSide}>
            <div className={styles.profileContainer}>
              <div className={styles.profileImageWrapper}>
                <div className={styles.profileImage}>
                  <div className={styles.profilePlaceholderWeb}>
                    <span className={styles.profileInitial}>WD</span>
                  </div>
                </div>
                <div className={styles.profileRing1Web}></div>
                <div className={styles.profileRing2Web}></div>
                <div className={styles.profileDot1Web}></div>
                <div className={styles.profileDot2Web}></div>
              </div>

              <div className={styles.funFactCardWeb}>
                <Code size={16} className={styles.funFactIconWeb} />
                <p className={styles.funFactText}>Coffee-driven code enthusiast</p>
              </div>
            </div>
          </div> */}

          <div className={styles.contentSide}>
            <div className={styles.aboutContentWeb}>
              <h3 className={styles.aboutHeading}>
                Frontend Developer & UI/UX Enthusiast
              </h3>

              <div className={styles.aboutText}>
                <p className={styles.paragraph}>
                  Hello! I'm a passionate web developer specializing in creating beautiful,
                  functional, and user-centered digital experiences. I combine technical
                  expertise with creative problem-solving to build websites that not only
                  look great but perform exceptionally.
                </p>

                <p className={styles.paragraph}>
                  With expertise in modern web technologies like React, Node.js, and
                  responsive design, I transform complex requirements into elegant solutions.
                  I'm committed to writing clean, maintainable code and staying current with
                  the latest industry trends.
                </p>

                <p className={styles.paragraph}>
                  Beyond coding, I enjoy collaborating with teams, mentoring junior developers,
                  and contributing to open-source projects.
                </p>
              </div>

              <div className={styles.skillsContainer}>
                <span className={styles.skillTagWeb}>React</span>
                <span className={styles.skillTagWeb}>JavaScript</span>
                <span className={styles.skillTagWeb}>TypeScript</span>
                <span className={styles.skillTagWeb}>Node.js</span>
                <span className={styles.skillTagWeb}>CSS/SASS</span>
                <span className={styles.skillTagWeb}>Responsive Design</span>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WebDesignAboutMe;